import React from "react";
import {
  Table,
  TableRow,
  TableBody,
  TableHead,
  TableHeader,
} from "../../design/table";
import { FinancialItem } from "../../models/FinancialItem";
import { Subheading } from "../../design/heading";
import FinancialItemListItem from "./FinancialListItem";
import FinancialItemButton from "../../components/FinancialItemButton";

interface Props {
  type: { title: string; id: string; description: string; order: number };
  items: FinancialItem[];
}

const FinancialItemListSection: React.FC<Props> = ({ type, items }) => {
  if (items.length === 0) return null;

  return (
    <div className="p-6 mb-8 bg-white border shadow-sm rounded-2xl dark:bg-zinc-900">
      <div className="flex items-center justify-between mb-6">
        <Subheading className="font-semibold tracking-wide uppercase text-muted-foreground">
          {type.title}
        </Subheading>
        {type.description}
        {/* Optional: you could also add a mini description or info icon here if you want */}
      </div>

      <Table className="w-full table-fixed">
        <TableHead>
          <TableRow>
            <TableHeader className="w-1/6">Name</TableHeader>
            <TableHeader className="w-1/12" />
            <TableHeader className="w-1/6">Date Acquired</TableHeader>
            <TableHeader className="w-1/6">Value</TableHeader>
            <TableHeader className="w-1/6">Debt</TableHeader>
            <TableHeader className="w-1/6">Equity</TableHeader>
            <TableHeader className="w-1/12">You</TableHeader>
            <TableHeader className="w-1/12">Them</TableHeader>
            <TableHeader className="w-1/12" />
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((financialItem) => (
            <FinancialItemListItem
              key={financialItem._id}
              financialItem={financialItem}
            />
          ))}
        </TableBody>
      </Table>

      {/* Button to add new financial item */}
      <div className="flex justify-end mt-6">
        <FinancialItemButton className="flex items-center p-6 px-4">
          + Add {type.title.slice(0, 1).toUpperCase() + type.title.slice(1)}
        </FinancialItemButton>
      </div>
    </div>
  );
};

export default FinancialItemListSection;
